import React from "react";
import { i18n } from '../../translate/i18n';
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Done from "@mui/icons-material/Check";
import Cancel from "@mui/icons-material/Close";

import {
  TableCell,
  Tooltip,
} from "@mui/material";

import { styles } from './TableActionButtons';

class TableActionConfirmButtons extends React.Component {

  okBtn = () => (
    <IconButton
      onClick={() => this.props.createComponent()}
      disabled={this.props.disabled}
      size="large">
      <Tooltip title={i18n.t('tooltipMatTableOver.add')}>
        <Done style={styles.confirm} />
      </Tooltip>
    </IconButton>
  );
  cancelBtn = () => (
    <IconButton
      onClick={() => this.props.createCancel()}
      disabled={this.props.disabled}
      size="large">
      <Tooltip title={i18n.t('tooltipMatTableOver.cancel')}>
        <Cancel style={styles.cancel} />
      </Tooltip>
    </IconButton>
  );

  render() {
    return (
      <TableCell component="th" scope="row">
        {this.cancelBtn()}
        {this.okBtn()}
      </TableCell>
    );
  }
}

export default TableActionConfirmButtons;